import {
  DefinitionList,
  DefinitionListItem,
  DefinitionTerm,
  DefinitionValue,
} from '@apex/component-library'
import { Text, VStack } from '@chakra-ui/react'
import React, { useContext } from 'react'
import { LayoutContext } from '../contexts/layout/LayoutContext'
import participantIds from './participantIds.json'

const ParticipantIdsPage = () => {
  const { headerHeight, footerHeight } = useContext(LayoutContext)

  return (
    <VStack
      align="flex-start"
      spacing={8}
      padding={4}
      overflowY="auto"
      height={`calc(100vh - ${headerHeight + footerHeight}px)`}
    >
      <Text as="h1" textStyle="h1">
        Common Participant IDs
      </Text>
      <DefinitionList borderTop="1px solid" borderColor="gray.400" width="40%">
        {participantIds.content.map(item => (
          <DefinitionListItem key={item.id}>
            <DefinitionTerm width="100%">{item.participant}</DefinitionTerm>
            <DefinitionValue width="auto">{item.id}</DefinitionValue>
          </DefinitionListItem>
        ))}
      </DefinitionList>
    </VStack>
  )
}

export default ParticipantIdsPage
